import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import HeaderCard from '../../components/Header/HeaderCard';
import TableList from '../../components/Tools/TableList';
import { apiService } from '../../components/Config/api.service';
import Hsp from './Hsp/Hsp';
import Absences from './Absence/Absence';
import SecondarySidebar from '../../components/SideBar/SecondarySidebar';
import { FaUserClock } from 'react-icons/fa';

const TimeManagement = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("hsp");
  const [loadingStats, setLoadingStats] = useState(true);
  const [absenceStats, setAbsenceStats] = useState({
    paid: 0,
    unpaid: 0,
    deducted: 0,
    additionalHours: 0
  });
  

  useEffect(() => {
    setLoadingStats(true);

    apiService.getElement('/absence_statistics')
      .then(response => {
        const stats = response.data;
        setAbsenceStats({
          paid: stats.absences.paid || 0,
          unpaid: stats.absences.unpaid || 0,
          deducted: stats.absences.deducted || 0,
          additionalHours: stats.additional_hours || 0
        });
      })
      .catch(error => {
        console.error('There was an error fetching the statistics!', error);
      });

      setLoadingStats(false);
  }, []);

  const menuItems = [
    { id: "hsp", label: t('leave.overtimeHours') },
    { id: "absences", label: t('leave.absencesAndLeave') },
  ];

  const renderContent = () => {
    switch (activeTab) {
      case "absences":
        return (
          <div>
            <Absences />
          </div>
        );

      case "hsp":
        return (
          <div>
            <Hsp />
          </div>
        );
      default:
        return (
          <div>
            <Absences />
          </div>
        );
    }
  };

  const getStatsIcon = (type) => {
    switch (type) {
      case 'paid': 
        return (
          <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"/>
          </svg>
        );
      case 'unpaid': 
        return (
          <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 14H5.236a2 2 0 01-1.789-2.894l3.5-7A2 2 0 018.736 3h4.018a2 2 0 01.485.06l3.76.94m-7 10v5a2 2 0 002 2h.096c.5 0 .905-.405.905-.904 0-.715.211-1.413.608-2.008L17.294 15M10 14l4-2c.707-.707 1.707-.707 2.414 0l2.292 2.292c.707.707.707 1.707 0 2.414L15 21"/>
          </svg>
        );
      case 'deducted': 
        return (
          <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
        );
      case 'additionalHours': 
        return (
          <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
        );
      default: 
        return (
          <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"/>
          </svg>
        );
    }
  };

  return (
    <div>
      <HeaderCard
        title={t('leave.title')}
        text={t('leave.subtitle')}
      />

      {/* Statistiques modernisées avec le même style que Primes */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 pb-4">
        {[
          {
            value: absenceStats.paid,
            title: t('leave.paidAbsences'),
            type: 'paid',
            subtitle: t('leave.paidAbsencesSubtitle')
          },
          {
            value: absenceStats.unpaid,
            title: t('leave.unpaidAbsences'),
            type: 'unpaid',
            subtitle: t('leave.unpaidAbsencesSubtitle')
          },
          {
            value: absenceStats.deducted,
            title: t('leave.deductedAbsences'),
            type: 'deducted',
            subtitle: t('leave.deductedAbsencesSubtitle')
          },
          {
            value: absenceStats.additionalHours,
            title: t('leave.overtimeHours'),
            type: 'additionalHours',
            subtitle: t('leave.overtimeHoursSubtitle')
          }
        ].map(({ value, title, type, subtitle }) => (
          <div
            key={type}
            className="bg-white rounded-xl p-6    hover:shadow-md transition-all duration-300 transform hover:-translate-y-1"
          >
            {loadingStats ? (
              <div className="flex items-center justify-between">
                <div className="flex-1">
                  <div className="h-4 w-24 bg-white/20 rounded animate-pulse mb-2"></div>
                  <div className="h-8 w-12 bg-white/20 rounded animate-pulse mb-2"></div>
                  <div className="h-3 w-20 bg-white/20 rounded animate-pulse"></div>
                </div>
                <div className="bg-white/20 rounded-full p-3">
                  <div className="w-6 h-6 bg-white/20 rounded"></div>
                </div>
              </div>
            ) : (
              <div className="flex items-center justify-between">
                <div className="flex-1">
                  <p className="  text-sm font-medium uppercase tracking-wide">
                    {title}
                  </p>
                  <p className="text-3xl font-bold mt-2">{value}</p>
                  <p className="  text-xs mt-1">{subtitle}</p>
                </div>
                <div className="bg-[--color-primary] backdrop-blur-sm rounded-full p-3">
                  {getStatsIcon(type)}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="flex gap-4">
        <div className="w-80 flex-shrink-0">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200">
            <div className="px-6 py-4 border-b border-gray-200">
              <div className="flex gap-3">                
                <div>
                  <h3 className="text-lg font-semibold text-gray-800">{t('leave.timeManagement')}</h3>
                  <p className="text-sm text-gray-600">{t('leave.timeManagementSubtitle')}</p>
                </div>
              </div>
            </div>
            <div className="p-2">
              <SecondarySidebar 
                activeTab={activeTab} 
                setActiveTab={setActiveTab} 
                menuItems={menuItems} 
              />
            </div>
          </div>
        </div>
        <div className="flex-1 bg-white rounded-lg shadow-md">
          {renderContent()}
        </div>
      </div>
    </div>
  );
};

export default TimeManagement;